/* istanbul ignore file */
import moment from 'moment';

export default class BulkPriceUpdateRequest {
  public roomId: string;
  public startDate: string;
  public endDate: string;
  public daysOfWeek: string;
  public amount: number;

  constructor(roomId: string, amount: number) {
    this.roomId = roomId;
    this.startDate = moment().format('YYYY-MM-DD');
    this.endDate = moment().format('YYYY-MM-DD');
    this.daysOfWeek = 'Mon,Tue,Wed,Thu,Fri,Sat,Sun';
    this.amount = amount;
  }
}
